/*
 * Author: Duncan Levings
 * 
 * Copyright (c) 2020 DuncanLevings
 */

export default {
    DAILY: 0,
    WEEKLY: 1,
    MONTHLY: 2
}